import React, { Fragment, useEffect, useState } from "react";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { teams } from "../../utils/constants";

function ConsolidatedReport(props) {
  const [consolidatedData, setConsolidatedData] = useState([]);
  const {month, year, newReports} = props
  const [currentDay, setCurrentDay] = useState(getDaysInMonth(year, month-1))
  
  function getDaysInMonth(year, month) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0-based index
    // If the provided year and month match the current year and month, return today's date
    if (+year === +currentYear && +month === +currentMonth) {
      return today.getDate();
    }
  
    // Otherwise, return the last day of the month
    return new Date(year, month + 1, 0).getDate();
  }
  function getStartAndEndOfMonthTimestamps(year, month) {
    // Months are zero-indexed in JavaScript (0 for January, 11 for December)
    const startDate = new Date(year, month - 1, 1); // Start of the month
    const endDate = new Date(year, month, 0); // End of the month (0th day of the next month)
  
    // Convert to timestamps (in seconds)
    const startTimestamp = Math.floor(startDate.getTime() / 1000);
    const endTimestamp = Math.floor(endDate.getTime() / 1000);
  
    return { startTimestamp, endTimestamp };
  }
  
  const { startTimestamp, endTimestamp } = getStartAndEndOfMonthTimestamps(year, month);

  
  const getTimestamp = (times) => {
    const startDate = new Date(year, month - 1, 1); 
    // Convert to timestamps (in seconds)
    const timestampFirstDayOfMonth = Math.floor(startDate.getTime() / 1000);
    return timestampFirstDayOfMonth + (times * 86400)
  }
  const calculateTotal = (index) =>{
   let total = 0 
   teams.map((fieldname, i) => {
   total +=  getRevenueForTeamAndDate(fieldname.value,getTimestamp(index))
  })
  return parseFloat(total).toFixed(2)
}
  
  const getRevenueForTeamAndDate = (teamName, date) => {
    const teamEntry = consolidatedData.find(
      (entry) => entry.team === teamName && entry.date === date
    );

    // If the entry exists, return the total revenue
    if (teamEntry) {
      return teamEntry.totalRevenue;
    }

    // If the entry doesn't exist, return 0 or handle accordingly based on your use case
    return 0;
  };

  const fetchReport = async () => {
    try {
      let res = await api({
        url: "/reports/consolidatedreports",
        method: "POST",
        responseType: "json",
        data: {
          startTimestamp,
          endTimestamp,
          newReport:newReports
        },
      });
      if (res.code === 200) {
        setConsolidatedData(res.data);
      } else {
        Toast("error", res.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCurrentDay = ()=>{
    setCurrentDay(getDaysInMonth(year, month -1))
  }

  const getTeamTotal = (columnIndex) => {
    let total = 0;
    consolidatedData.map((entry) => {
      if (entry.team === teams[columnIndex].value) {
        total += entry.totalRevenue
      }
    })
    return total.toFixed(2);
  };

  const calculateAllTeamTotal = () => {
    let total = 0;
    consolidatedData.map((entry) => {
      total += parseFloat(entry.totalRevenue);
    })
    return total.toFixed(2);
  };

  useEffect(()=>{
    fetchReport()
    handleCurrentDay()
  },[month, year, newReports])
  return (
    <div className="report-image">
      
      <div className="overflow-x-auto responsive-table">
        <table className="table table-bordered report-table" id="consolidated-report">
          <thead>
            <tr><td className="p-0" colSpan={13}><h4>Consolidated Report-Local</h4></td></tr>
            <tr>
              <th>Date</th>
              {teams.slice(0, 12).map((fieldname, index) => {
                return <th>{fieldname.label}</th>;
              })}
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: currentDay }, (_, index1) => (
              <tr key={index1}>
                <td>{`${index1 + 1}-${month}-${year}`}</td>
                {teams.slice(0, 12).map((fieldname, index) => {
                return <td>{parseFloat(getRevenueForTeamAndDate(fieldname.value,getTimestamp(index1))).toFixed(2)}</td>;
              })}
                <td>{calculateTotal(index1)}</td>
              </tr>
            ))}
            <tr>
              <td>Total</td>
              {teams.slice(0, 12).map((fieldname, index) => (
                <td key={index}>{getTeamTotal(index)}</td>
              ))}
              <td>{calculateAllTeamTotal()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ConsolidatedReport;
